module.exports = __webpack_public_path__ + "static/img/news2.7eb5d24d.png";